import { Loader, Stack } from "@mantine/core";

import { SYSTEM_COLORS } from "@/configs/colorScheme";

export const LoadingSpinner = () => {
  return (
    <Stack h="100vh" w="100%" align="center" justify="center">
      <Loader size="sm" color={SYSTEM_COLORS.default} type="dots" />
    </Stack>
  );
};

export default LoadingSpinner;
